import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { catchError, EMPTY } from 'rxjs';
import { ChangePasswordReq, SignupReq } from 'src/app/api/contracts/auth';
import { AuthService } from 'src/app/auth/auth.service';
import { APP_CONFIG, AppConfig } from 'src/app/config/app-config';
import { LoaderController } from 'src/app/utils/loader-controller';
import { confirmPasswordFormValidator } from 'src/app/validators/confirm-password.validator';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./../auth-common.scss', './change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  readonly form: FormGroup<
    Record<keyof Pick<SignupReq, 'password' | 'confirmPassword'>, FormControl>
  >;

  public readonly loader = new LoaderController();
  public requestFailedWithError: boolean = false;

  constructor(
    private readonly navCtrl: NavController,
    @Inject(APP_CONFIG) private readonly appConfig: AppConfig,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService
  ) {
    this.form = new FormGroup({
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(this.appConfig.fieldValidation.password.minLength),
        Validators.maxLength(64),
        Validators.pattern(this.appConfig.fieldValidation.password.pattern),
      ]),
      confirmPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(this.appConfig.fieldValidation.password.minLength),
        Validators.maxLength(64),
        Validators.pattern(this.appConfig.fieldValidation.password.pattern),
      ]),
    });
    this.form.setValidators(
      confirmPasswordFormValidator('password', 'confirmPassword')
    );
  }

  ngOnInit() {
    this.form.valueChanges.subscribe(() => {
      this.requestFailedWithError = false;
    });
  }

  onResetPasswordClick(): void {
    const hash = this.route.snapshot.queryParams['hash'];
    this.loader.enqueue();
    this.form.disable();
    this.requestFailedWithError = false;
    const body: ChangePasswordReq = {
      password: this.form.controls.password.value,
      confirmPassword: this.form.controls.confirmPassword.value,
      hash,
    };
    this.authService
      .changePassword(body)
      .pipe(
        catchError((err) => {
          this.form.enable();
          this.loader.dequeue();
          this.requestFailedWithError = true;
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.form.enable();
        this.loader.dequeue();
        this.navCtrl.navigateRoot('login');
      });
  }

  onCancelClick(): void {
    this.navCtrl.navigateRoot('login');
  }
}
